import { __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { useTheme } from '../hooks/useTheme.js';
import { Box } from '../Box/index.js';

var SelectLegacySection = function (props) {
    var handleStyleProps = useTheme().handleStyleProps;
    var forwardProps = handleStyleProps(props, { themeKey: "selectSection" });
    return jsx(Box, __assign({}, forwardProps));
};
SelectLegacySection.displayName = "SelectLegacySection";

export { SelectLegacySection };
//# sourceMappingURL=SelectLegacySection.js.map
